// @flow

import React from 'react';

import { EarlyAccessButton } from '@zapier/design-system-app-profiles';
import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/common-components';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import earlyAccessButtonQuery from 'web-ssr/app/app-directory/components/EarlyAccessButton/earlyAccessButtonQuery';

import type {
  earlyAccessButtonQuery as earlyAccessButtonQueryType,
  earlyAccessButtonQueryVariables,
} from 'web-ssr/graphql/types';

type Result = {
  loading: *,
  fetchMore: *,
  error: *,
  data: earlyAccessButtonQueryType,
};

type Props = {
  appSlug: string,
};

const EarlyAccessButtonContainer = (props: Props) => {
  const variables: earlyAccessButtonQueryVariables = {
    slug: props.appSlug,
  };

  const layoutProps = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'small' },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'large' },
  });

  return (
    <ApolloQuery query={earlyAccessButtonQuery} variables={variables}>
      {({ data }: Result) => {
        const { appBySlug } = data || {};

        if (!appBySlug || !appBySlug.inviteUrl) {
          return null;
        }

        return (
          <EarlyAccessButton
            appIconSrc={appBySlug.image || ''}
            appInviteUrl={appBySlug.inviteUrl}
            appName={appBySlug.name}
            size={layoutProps.size}
          />
        );
      }}
    </ApolloQuery>
  );
};

export default EarlyAccessButtonContainer;
